/**
 * Плагин: при создании нового edge (connection) создаём связь в модели и заменяем временный edge на «настоящий».
 */
import {RELATIONSHIP_ASSOCIATION} from '../metamodel/Concept';
import * as connectionModel from '../modelerX6/ConnectionModel';
import {applyViewpointDimming} from '../viewpoint/applyViewpointDimming';

export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;

		const onEdgeConnected = args => {
			if (modeler._addingConnections) return;
			const edge = args?.edge;
			if (!edge || typeof edge.isEdge !== 'function' || !edge.isEdge()) return;
			// Переподключение существующей связи (стрелки source/target): модель и патч
			// updateConnection обрабатывает edgeTerminalChangePlugin по cell:change:source/target.
			// Иначе этот же handler создаст вторую relationship + remove/add и сбросит тип на Association.
			const existingView = modeler._findViewElementById?.(edge.id);
			if (existingView?.relationshipRef) return;
			const sourceId =
				edge.getSourceCellId?.() ?? edge.getSource?.()?.cell ?? edge.getSourceCell?.()?.id;
			const targetId =
				edge.getTargetCellId?.() ?? edge.getTarget?.()?.cell ?? edge.getTargetCell?.()?.id;
			if (!sourceId || !targetId) return;
			const srcNode = modeler._findViewElementById(sourceId);
			const tgtNode = modeler._findViewElementById(targetId);
			if (!srcNode || !tgtNode) return;
			if (!modeler._canConnectViewNodes(srcNode, tgtNode)) {
				modeler._edgeFactory.remove(edge);
				return;
			}
			const relationshipType =
				modeler._pendingConnection?.sourceId === sourceId
					? modeler._pendingConnection.type
					: RELATIONSHIP_ASSOCIATION;
			if (modeler._pendingConnection?.sourceId === sourceId)
				modeler._pendingConnection = null;
			if (
				!modeler._isRelationshipTypeAllowedForConnection(srcNode, tgtNode, relationshipType)
			) {
				modeler._edgeFactory.remove(edge);
				return;
			}
			const result = connectionModel.createConnection(
				modeler,
				srcNode,
				tgtNode,
				relationshipType
			);
			if (!result) return;
			const {connectionId, relationshipRefId, bendpoints} = result;
			const vertices = edge.getVertices?.() ?? [];
			const waypoints = vertices.length
				? vertices.map(p => ({x: p.x ?? p.$x ?? 0, y: p.y ?? p.$y ?? 0}))
				: bendpoints;
			modeler._edgeFactory.remove(edge);
			modeler._edgeFactory.createAndAdd({
				id: connectionId,
				source: sourceId,
				target: targetId,
				vertices: waypoints,
				relationshipType,
				lineColor: '#000000',
			});
			onPatch({
				patches: [
					{
						op: 'addConnection',
						viewIndex: VIEW_INDEX,
						connection: {
							identifier: connectionId,
							source: sourceId,
							target: targetId,
							relationshipRef: relationshipRefId,
							type: relationshipType,
							bendpoints: waypoints,
						},
					},
				],
			});
			applyViewpointDimming(modeler);
		};

		graph.on('edge:connected', onEdgeConnected);

		return () => graph.off('edge:connected', onEdgeConnected);
	},
};
